/* eslint-disable import/no-default-export */
import { normalizeLabel } from 'api/normalize';
// eslint-disable-next-line no-restricted-imports
import { LabelModel, LabelResponse } from 'types';
// eslint-disable-next-line no-restricted-imports
import { createReducer } from 'util/reducers';
import { PERFORM_SEARCH_SUCCESS, PerformSearchSuccessAction } from './search';

// Reducer
export interface LabelState {
  [labelId: string]: LabelModel;
}

const initialState: LabelState = {};

export default createReducer(initialState, {
  [PERFORM_SEARCH_SUCCESS](state, { payload }: PerformSearchSuccessAction) {
    if (!payload.cards) {
      return state;
    }

    return payload.cards
      .reduce(
        (allLabels, card) => allLabels.concat(card.labels || []),
        [] as LabelResponse[],
      )
      .reduce((endState, label) => {
        if (!endState[label.id]) {
          endState[label.id] = normalizeLabel(label);
        }

        return endState;
      }, state);
  },
});



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/models/labels.ts